import React, { useContext } from 'react';

import cx from 'classnames';
import { ModuleHeader, PageContext } from '@xingternal/pages-common';
import { trackAwardAction, getTrackingUrl } from '@xingternal/pages-tracking';

import { Card } from '@xingternal/card';
import styles from './Awards.css';

type AwardsProps = {
  badges: { awardUrl: string; image: Image }[];
  pageSlug: string;
};

type Image = {
  url: string;
}[];

const Awards = ({ badges, pageSlug }: AwardsProps) => {
  const AWARDS_NUMBER = 4;
  const { pageContext } = useContext(PageContext);

  const showMore =
    badges.length > AWARDS_NUMBER
      ? {
          to: getTrackingUrl({
            to: `${pageContext?.basePath}/${pageSlug}/about_us?scroll=awards`,
            trackingKey: 'allAwards',
          }),
          copyKey: 'EP_SEE_ALL_AWARDS',
        }
      : null;

  const slicedBadges = badges.slice(0, AWARDS_NUMBER);

  return (
    <>
      <ModuleHeader
        headlineCopyKey="EP_AWARDS_HEADLINE"
        showMore={showMore}
        small={true}
      />

      {slicedBadges.map((badge, index) => (
        <Card
          target={'_blank'}
          href={badge.awardUrl}
          onClick={() => trackAwardAction('entity_page_mainpage')}
          linkProps={{
            // @ts-ignore
            "aria-label": "award link",
          }}
          className={cx(styles.imageWrapper, {
            [styles.hideContentMobile]: index > 1,
          })}
          key={index}
        >
          <img
            src={badge.image[0].url}
            className={styles.image}
            loading="lazy"
            alt="Award"
          />
        </Card>
      ))}
    </>
  );
};

export default Awards;
